import { history } from "common/services/history"
import findClientByTask from "./sign/findClientByTask"
import addTicketUseCase from "tickets/services/addTicketUseCase"
import updateTicketDetailUseCase from "tickets/services/detail/updateTicketDetailUseCase"
import updateTaskUseCase from "./updateTaskUseCase"

const addTicketFromTaskUseCase = async (tasks) => {
    let idTicket = null

    const mapTaskByClient = {}

    tasks.forEach(task => {
        const { reference, description, budget, dni, deviceName, imei, refClient } = task
        const taskMap = mapTaskByClient[dni]

        const dataItem = {
            reference: reference || "",
            description: task.concept = `${deviceName || "Dispositivo"} - ${description || "Averia"} - ${imei || ''} - ${refClient || ''}` || "",
            unitPrice: budget || 0,
            units: 1,
            iva: task.iva !== undefined ? task.iva !== false : true
        }

        if (taskMap) {
            taskMap.data.push(dataItem)
            return
        }

        mapTaskByClient[task.dni] = { ...task, data: [dataItem] }
        updateTaskUseCase({...task, payed: 1 }, task)
    })

    
    for (let i = 0; i < Object.keys(mapTaskByClient).length; i++) {
        const key = Object.keys(mapTaskByClient)[i]
        const { reference, dni, data, deviceName, imei, refClient, description, iva: taskIva } = mapTaskByClient[key]

        let ticket = {
            taskReference: reference,
            concept: `${deviceName || "Dispositivo"} - ${description || "Averia"} - ${imei || ''} - ${refClient || ''}` || ""
        }

        if (dni) {
            const client = await findClientByTask(dni)
            // Para tareas antiguas sin iva definido, usar preferencia del cliente como fallback
            if (taskIva === undefined) {
                data.forEach(item => { item.iva = client.iva !== false })
            }
            ticket = {
                ...ticket,
                dniClient: dni,
                nameClient: client.name || "",
                codClient: client.codClient || 0
            }
        }

        idTicket = await addTicketUseCase(ticket)
        
        await updateTicketDetailUseCase({...ticket, id: idTicket }, null, { data })
    }
    
    history.push(`/tickets?id=${idTicket}`)
}

export default addTicketFromTaskUseCase